module.exports = __webpack_public_path__ + "media/images/icon-comment-etc-on@3x-d64cf291e266a89188ddd2bfd259b774.png";